import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initializeRaygun } from '@/services/monitoring';
import App from './App';
import '@itential/mosaic-styles';
import 'primeicons/primeicons.css';
import './index.css';

initializeRaygun();

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
